module.exports = "/static/assets/d7cb3ae0db990e0bab94ac154ecedcd1.gif";